import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const StyledImage = styled('img', {
  shouldForwardProp: muiPropForwarding(
    'objectFit',
    'focalPointX',
    'focalPointY'
  )
})(({ objectFit, focalPointX, focalPointY }) => ({
  position: 'relative',
  objectPosition:
    focalPointX && focalPointY
      ? `${focalPointX * 100}% ${focalPointY * 100}%`
      : 'initial',
  height: '100%',
  width: '100%',
  objectFit
}));

const Image = props => {
  const { src, height, objectFit, focalPointX, focalPointY } = props;

  return (
    <StyledImage
      objectFit={objectFit}
      focalPointX={focalPointX}
      focalPointY={focalPointY}
      src={src}
      alt="menu-item"
      height={height}
      data-testid="image-id"
    />
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  height: PropTypes.string,
  objectFit: PropTypes.oneOf(['cover', 'contain']),
  focalPointX: PropTypes.number,
  focalPointY: PropTypes.number
};

Image.defaultProps = {
  objectFit: 'cover'
};

export default Image;
